import { Nice, niceText } from "@/components/Nice";

export const WHY_NICE = [
  "In an AI age that makes it easier than ever for children to simply ask for what they want and receive an immediate response, NICE helps ensure that convenience does not replace character.",
  "NICE teaches children that how we ask, respond, apologize, show gratitude, and communicate matters—because respect, empathy, manners, and consideration are the foundations of healthy relationships with peers, siblings, parents, teachers, and eventually the larger world.",
];

export const WhyNice = ({ className = "" }) => (
  <section className={`pp-card pp-why ${className}`} data-testid="why-nice">
    <p className="pp-slogan-lg" data-testid="why-nice-slogan">Developing Character Before Convenience</p>
    <p className="pp-label mt-3">Why <Nice />?</p>
    {WHY_NICE.map((p, i) => <p key={p} className={i ? "mt-3" : "pp-why-lead"}>{niceText(p)}</p>)}
  </section>
);
